export default function heroThumbnailImage() {
    const heroImage = document.querySelector('.js-hero-image');
    const hero = document.querySelector('.js-hero');

    if (!hero || !heroImage) {
        return;
    }

    function showHide() {
        if (window.innerWidth >= 992) {
            const {height} = hero.getBoundingClientRect();
            heroImage.style.marginTop = `-${height - 140}px`;
            heroImage.classList.remove('hidden');
        } else {
            heroImage.classList.add('hidden');
        }
    }

    showHide();
    window.addEventListener('resize', showHide);
}
